import './App.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useRoute } from 'react-router5';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Header, Placeholder } from '$uikit';
import { appActions, appInfoSelector, appLoadingStatusSelector } from '$store/app';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';
import { AppContainer } from '$core/App/AppContainer/AppContainer';

export const App: FC = () => {
  const { route } = useRoute();
  const appId = route.params.id;

  const dispatch = useDispatch();
  const t = useTranslator();
  const loadingStatus = useSelector(appLoadingStatusSelector);
  const app = useSelector(appInfoSelector);

  const loadData = useCallback(() => {
    dispatch(appActions.loadApp({ appId }));
  }, [appId]);

  useEffect(() => {
    loadData();
  }, [appId]);

  function renderContent() {
    if (loadingStatus === 'loading') {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={loadData}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    return <AppContainer />;
  }

  return (
    <>
      <Header showCloseButton>{app ? app.name : ''}</Header>
      {renderContent()}
    </>
  );
};
